import React, { lazy, Suspense } from "react";
import LazyLoader from "../../components/common/loader/lazyLoader";
const ListSubCategory = lazy(() =>
  import("../../components/subCategory/listSubCategory")
);

const ListSubCategoryPage = () => {
  return (
    <Suspense fallback={<LazyLoader />}>
      <ListSubCategory />
    </Suspense>
  );
};

export default ListSubCategoryPage;
